import axios from 'axios';

export const downloadFile = async (downloadLink: string, filename?: string) => {
  try {
    const response = await axios.get<Blob>(downloadLink, {
      responseType: 'blob',
      // onDownloadProgress(progressEvent) {
      //   const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);

      //   console.log(`>>>> Download progress: ${percentCompleted}%`);
      // },
    });

    const blob = response.data;
    const downloadUrl = new URL(downloadLink);
    const fileName = filename ?? downloadUrl.pathname.split('/').pop();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');

    a.style.display = 'none';
    a.href = url;
    a.download = fileName;
    a.target = '_blank';
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
  } catch (err) {
    console.error('Error downloading file:', err);
  }
};
